import DocusaurusFooter from '../DocusaurusFooter'
import KickStartFooter from '../KickStartFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import {
  LinkToAddModel,
  LinkToImportModel,
  useSpaceAccess
} from '@eggplant/routing'
import { models } from '../../docs-routes'

const Models = () => {
  const [isAccess] = useSpaceAccess()

  return (
    <Paragraph>
      <Color
        display='inline'
        variant='theme-description-text'
      >
        {
          isAccess
            ? <>Eggplant DAI models are simple visual representations of the application, interface, or website that you want to test. You can <LinkToAddModel>create a new model</LinkToAddModel> or <LinkToImportModel>import a model</LinkToImportModel> using a .json file.</>
            : 'Eggplant DAI models are simple visual representations of the application, interface, or website that you want to test.'
        }
      </Color>
      {
        isAccess &&
          <KickStartFooter />
      }
      <DocusaurusFooter path={models} />
    </Paragraph>
  )
}

export default Models
